<template>
  <div id="app">
    <!-- 顶部环境光晕层 -->
    <div class="tech-ambient-glow tech-glow-top"></div>
    <div class="tech-ambient-mesh"></div>
    
    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>

    <!-- 底部环境光晕层 -->
    <div class="tech-ambient-glow tech-glow-bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1E1235;
  background-color: #FAF7FD;
  background-image: 
    radial-gradient(ellipse 90% 45% at 50% -5%, rgba(216, 180, 254, 0.45) 0%, rgba(243, 232, 255, 0.2) 60%, transparent 80%),
    radial-gradient(ellipse 70% 35% at 50% 105%, rgba(192, 132, 252, 0.25) 0%, rgba(125, 211, 252, 0.15) 50%, transparent 75%),
    linear-gradient(180deg, #FAF7FD 0%, #F5EEFD 40%, #EFE5FA 100%);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 50px rgba(124, 58, 237, 0.08);
}

/* 顶部与底部梦幻极光与科技金融氛围 (浅色柔和漫射) */
.tech-ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(60px);
}

.tech-glow-top {
  top: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 280px;
  background: radial-gradient(circle, rgba(233, 213, 255, 0.6) 0%, rgba(244, 114, 182, 0.18) 45%, rgba(103, 232, 249, 0.12) 65%, transparent 75%);
}

.tech-glow-bottom {
  bottom: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 240px;
  background: radial-gradient(circle, rgba(192, 132, 252, 0.3) 0%, rgba(165, 243, 252, 0.18) 50%, transparent 70%);
}

/* 科技金融微细网格纹理 (浅色半透) */
.tech-ambient-mesh {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 500px;
  margin: 0 auto;
  pointer-events: none;
  z-index: 0;
  opacity: 0.25;
  background-image: 
    radial-gradient(rgba(147, 51, 234, 0.15) 1px, transparent 1px),
    repeating-linear-gradient(45deg, rgba(147, 51, 234, 0.03) 0, rgba(147, 51, 234, 0.03) 1px, transparent 0, transparent 40px);
  background-size: 24px 24px, auto;
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
